/**
 * JSON-LD structured data generator for LexiQuest.
 *
 * Returns plain objects — the SEO component serializes them into <script> tags.
 */

import { DEFAULTS, SITE_URL } from './seo.config';

/** Schema.org WebSite — enables sitelinks search box in Google results. */
export function websiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: DEFAULTS.siteName,
    url: SITE_URL,
    description: DEFAULTS.description,
    inLanguage: 'en',
  };
}

/** Schema.org VideoGame — primary structured data for the game. */
export function gameSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'VideoGame',
    name: 'LexiQuest',
    url: SITE_URL,
    description:
      'A semantic word exploration game. Navigate from a starting word to a target word ' +
      'through a force-directed graph of semantically similar words.',
    genre: ['Word Game', 'Puzzle Game', 'Educational Game'],
    gamePlatform: 'Web Browser',
    applicationCategory: 'Game',
    operatingSystem: 'Any',
    playMode: ['SinglePlayer', 'MultiPlayer'],
    numberOfPlayers: {
      '@type': 'QuantitativeValue',
      minValue: 1,
      maxValue: 8,
    },
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
      availability: 'https://schema.org/InStock',
    },
    inLanguage: 'en',
  };
}

/** Schema.org BreadcrumbList for basic navigation context. */
export function breadcrumbSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
}
